import { IconName, isIconName } from '@secretescapes/falcon';

export const getFacilityIconName = (key: string, groupKey: string) => {
  if (isIconName(key)) {
    return IconName[key];
  }

  return isIconName(groupKey) ? IconName[groupKey] : IconName.general;
};
